/**
 * @namespace ThemeEvents
 * @description Une collection d'événements spécifiques au thème qui peuvent être utilisés pour déclencher et écouter des changements partout dans le thème.
 * @example
 * document.dispatchEvent(new VariantUpdatedEvent(variant, sectionId, { html }));
 * document.addEventListener(ThemeEvents.variantUpdated, (e) => { console.log(e.detail.variant) });
 */

export class ThemeEvents {
  static cartUpdated = 'cart:updated';
  static cartOpen = 'cart:open';
  static cartClose = 'cart:close';
  static variantSelected = 'variant:selected';
  static variantUpdated = 'variant:updated';
  static filtersChanged = 'filters:changed';
  static filtersUpdated = 'filters:updated';
  static toggleCrossSellsUpdated = 'toggle-cross-sells:updated';
  static quantityBreaksUpdated = 'quantity-breaks:updated';
  static subscriptionUpdated = 'subscription:updated';
  static formUpdated = 'form:updated';
  static wishlistUpdated = 'wishlist:updated';
  static wishlistItemAdded = 'wishlist:item-added';
  static wishlistItemRemoved = 'wishlist:item-removed';
}

export class CartUpdatedEvent extends Event {
  constructor(resource, data) {
    super(ThemeEvents.cartUpdated, { bubbles: true });
    this.detail = {
      resource,
      data: {
        ...data,
      },
    };
  }
}

export class VariantSelectedEvent extends Event {
  constructor(resource) {
    super(ThemeEvents.variantSelected, { bubbles: true });
    this.detail = {
      resource,
    };
  }
}

export class VariantUpdatedEvent extends Event {
  constructor(resource, sourceId, data) {
    super(ThemeEvents.variantUpdated, { bubbles: true });
    this.detail = {
      resource: resource || null,
      sourceId,
      data: {
        html: data.html,
        productId: data.productId,
      },
    };
  }
}

export class FiltersChangedEvent extends Event {
  constructor(filter_params, sorting_params) {
    super(ThemeEvents.filtersChanged, { bubbles: true });
    this.detail = {
      filter_params,
      sorting_params,
    };
  }
}

export class FiltersUpdatedEvent extends Event {
  constructor() {
    super(ThemeEvents.filtersUpdated, { bubbles: true });
  }
}

export class ToggleCrossSellsUpdatedEvent extends Event {
  constructor() {
    super(ThemeEvents.toggleCrossSellsUpdated, { bubbles: true });
  }
}

export class QuantityBreaksUpdatedEvent extends Event {
  constructor() {
    super(ThemeEvents.quantityBreaksUpdated, { bubbles: true });
  }
}

export class SubscriptionUpdatedEvent extends Event {
  constructor() {
    super(ThemeEvents.subscriptionUpdated, { bubbles: true });
  }
}

export class FormUpdatedEvent extends Event {
  constructor(prices) {
    super(ThemeEvents.formUpdated, { bubbles: true });
    this.detail = { prices };
  }
}

export class WishlistUpdatedEvent extends Event {
  constructor(items, count) {
    super(ThemeEvents.wishlistUpdated, { bubbles: true });
    this.detail = {
      items,
      count,
    };
  }
}

export class WishlistItemAddedEvent extends Event {
  constructor(item) {
    super(ThemeEvents.wishlistItemAdded, { bubbles: true });
    this.detail = {
      item,
    };
  }
}

export class WishlistItemRemovedEvent extends Event {
  constructor(productId) {
    super(ThemeEvents.wishlistItemRemoved, { bubbles: true });
    this.detail = {
      productId,
    };
  }
}

export default ThemeEvents;
